import { setLoggingLevel } from '@dreryk/typescript-logger';

const LOGS_SERIALIZATION = process.env.NODE_ENV !== 'development';
setLoggingLevel(window?.APP_ENV?.logLevel, LOGS_SERIALIZATION);
